var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cTable',{ref:"table",attrs:{"fields":_vm.fields,"header":_vm.header,"methods":_vm.methods,"modals":_vm.modals,"config":_vm.config,"footer":_vm.footer},scopedSlots:_vm._u([{key:"DETAIL",fn:function(ref){
var visible = ref.visible;
var params = ref.params;
return [(visible)?_c('order',{attrs:{"orderDetails":params.dataDetails}}):_vm._e()]}},{key:"tracker",fn:function(ref){
var visible = ref.visible;
var params = ref.params;
return [(visible)?_c('tracker',{attrs:{"fn":_vm.methods.getOrderStatus,"statusId":params.id}}):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }